// Others
import axiosClient from './axiosClient';
import { urlApiPayment } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IPayment, IQueryParamPayment } from '~/utils/interface/payment';
import { IPaymentQuote } from '~/utils/interface/quotes';

const paymentApi = {
  getListPayment: (params: IQueryParamPayment) => {
    const url = urlApiPayment.getList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IPayment[]>>>(url, { params });
  },

  createPayment: (body: IPaymentQuote) => {
    const url = urlApiPayment.create;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default paymentApi;
